document.addEventListener('DOMContentLoaded', function () {
    function showSection(category) {
        document.querySelectorAll('[class^="section__"]').forEach(section => section.classList.remove('visible'));
        document.querySelectorAll('.section__' + category).forEach(section => section.classList.add('visible'));
    }

    function setActiveLink(category) {
        document.querySelectorAll('.faq-menu__link').forEach(link => link.classList.remove('active-dot', 'right'));

        const activeLink = document.querySelector('.faq-menu__link[href="?' + category + '"]');
        if (activeLink) {
            activeLink.classList.add('active-dot', 'right');
        }
    }

    const params = new URLSearchParams(window.location.search);
    const category = params.keys().next().value;

    if (category) {
        showSection(category);
        setActiveLink(category);
    } else {
        const firstCategoryElement = document.querySelector('faq-select div[class^="section__"]');
        if (firstCategoryElement) {
            const firstCategoryClass = firstCategoryElement.className.match(/section__([^\s]+)/)[1];
            showSection(firstCategoryClass);
            setActiveLink(firstCategoryClass);
        }
    }

    document.querySelectorAll('.faq .faq-menu__link').forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault();
            const category = this.getAttribute('href').substring(1);

            window.history.pushState({}, '', '?' + category);
            showSection(category);
            setActiveLink(category);
        });
    });

    window.addEventListener('popstate', function () {
        const category = new URLSearchParams(window.location.search).keys().next().value;
        if (category) {
            showSection(category);
            setActiveLink(category);
        }
    });

    if (Shopify.designMode) {
        document.querySelectorAll('[class^="section__"]').forEach(section => section.classList.add('visible'));
    }
});